import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicSessionOrganizationNamePipe } from './public-session-organization-name.pipe';

@NgModule({
  declarations: [PublicSessionOrganizationNamePipe],
  exports: [PublicSessionOrganizationNamePipe],
  imports: [CommonModule],
})
export class PublicSessionOrganizerOrganizationNameModule {}
